import { useTheme } from '../lib/theme';

/** Переключатель светлой и тёмной темы. Значок показывает, куда переключит. */
export function ThemeToggle() {
  const { theme, toggle } = useTheme();
  const toDark = theme === 'light';

  return (
    <button
      onClick={toggle}
      title={toDark ? 'Тёмная тема' : 'Светлая тема'}
      aria-label={toDark ? 'Включить тёмную тему' : 'Включить светлую тему'}
      className="flex h-[34px] w-[34px] items-center justify-center rounded-[9px] border border-border bg-surface-2 text-ink-dim hover:bg-border"
    >
      {toDark ? <MoonIcon /> : <SunIcon />}
    </button>
  );
}

function MoonIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SunIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="1.8" />
      <path
        d="M12 2v2.5M12 19.5V22M4.9 4.9l1.8 1.8M17.3 17.3l1.8 1.8M2 12h2.5M19.5 12H22M4.9 19.1l1.8-1.8M17.3 6.7l1.8-1.8"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}
